"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediaServicesNoImageIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m19.41 3.041.72-.72a1.095 1.095 0 1 1 1.55 1.548L3.87 21.68a1.095 1.095 0 1 1-1.55-1.55l.72-.72a2 2 0 0 1-.04-.405V4.995C3 3.893 3.893 3 4.995 3h14.01q.209 0 .405.041M21 7.531v11.474A1.995 1.995 0 0 1 19.005 21H7.53l3-3H18v-2.7l-2.271-2.498zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
}, props));
MediaServicesNoImageIcon.displayName = 'MediaServicesNoImageIcon';
var _default = exports.default = MediaServicesNoImageIcon;